import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useTranslation } from 'react-i18next'
import TechDebtTab from './TechDebtTab'

const TechDebtPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader
        title={t('breadcrumbs.techDebt')}
        breadcrumbs={{
          path: [{ href: '/techdebt', label: t('breadcrumbs.techDebt') }],
        }}
      />
      <PageContainer>
        <TechDebtTab />
      </PageContainer>
    </>
  )
}

export default TechDebtPage
